import React, {FC, useState} from 'react';
import { useTranslation } from 'react-i18next';
import styles from "./about.module.scss"
import {sections} from "./const";
import DescriptionSection from "./description-sections/description-sections";
import Button from '../../ui-kit/button/button';

const About: FC = () => {
    const { t } = useTranslation();
    const [activeButton, setActiveButton] = useState<number>(1);

    const handleButtonClick = (id: number): void => {
        setActiveButton(id)
    }

    return (
        <div id='about' className={styles.about}>
            <div className={styles.container}>
                <div className={styles.aboutInner}>
                    <div className={styles.btns}>
                        <Button
                            type="current"
                            isActive={activeButton === 1}
                            className={`${styles.btn}`}
                            onClick={()=>handleButtonClick(1)}
                        >
                            {t('about.welcome')}
                        </Button>
                        <Button
                            type="current"
                            isActive={activeButton === 2}
                            className={styles.btn}
                            onClick={()=>handleButtonClick(2)}
                        >
                            {t('about.whyInvest')}
                        </Button>
                        <Button
                            type="current"
                            isActive={activeButton === 3}
                            className={styles.btn}
                            onClick={()=>handleButtonClick(3)}
                        >
                            {t('about.partnershipServices')}
                        </Button>
                    </div>
                    {sections[activeButton] && <DescriptionSection items={sections[activeButton]} />}
                </div>
            </div>
        </div>
    );
};

export default About;
